import { BaseError, type BaseErrorParameters } from '@dynamic-labs-sdk/client';

export type RpcErrorParameters = Pick<BaseErrorParameters, 'shortMessage'> &
  Partial<Omit<BaseErrorParameters, 'shortMessage'>>;

export class RpcError extends BaseError {
  constructor(args: RpcErrorParameters) {
    super({
      cause: args.cause ?? null,
      code: args.code ?? 'rpc_error',
      details: args.details,
      docsUrl: args.docsUrl ?? null,
      metaMessages: args.metaMessages,
      name: args.name ?? 'RpcError',
      shortMessage: args.shortMessage,
    });
  }
}
